import type { ElementId } from '../../../shared/domain/flows/types.no-deps'
import type { ReportClientId } from '../../../shared/domain/reports/types.no-deps'
import { getVersionIdentifier } from '../../../shared/domain/workflows/types.no-deps'
import { v4 as uuidv4 } from 'uuid'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import { Logg_createLogger } from '../Logg/Logg.Logger'
import { Flow_fetchReport } from './Flow.Report'
import { IDB_workflowFeedback } from '../IDB/IDB.dexie'
import { Serv_client } from '../Serv/Serv.client'
import type { LoopPath } from '../../../shared/domain/flows/LoopPath.no-deps'

export async function Flow_saveFeedback(
    elementId: ElementId,
    message: string,
    reportId: ReportClientId,
    loopPath?: LoopPath
) {
    const logger = Logg_createLogger(`Flow_saveFeedback`)

    const report = await Flow_fetchReport(logger, reportId)
    const workflow = getVersionIdentifier(report.workflow)

    IDB_workflowFeedback().add({
        id: uuidv4() as UUID,
        workflow: workflow.id,
        workflowVersion: workflow.version,
        element: elementId,
        message,
        createdAt: new Date(),
        subjectUnit: report.subjectUnit?.id,
        loopPath,
    })
}

export async function Flow_syncFeedback() {
    const logger = Logg_createLogger(`Flow_syncFeedback`)

    try {
        const toSync = await IDB_workflowFeedback().toArray()
        await Serv_client.bulkAddWorkflowFeedbacks(toSync)
    } catch (e) {
        throw logger.error(e)
    }

    await IDB_workflowFeedback().clear()
}
